export default "__VITE_ASSET__CrYKMYtc__"